import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useGetConfigs } from '../hooks/useGetConfigs';
import routes from '../routes/index';
import { isManagerRole, UserRole } from '../views/users/constant';

function useRoutes(initialValue = false) {
  const Deliveries = React.lazy(() => import('../views/Deliveries/Deliveries.jsx'));

  const LicensePlates = React.lazy(() => import('../views/license-plates/LicensePlates.jsx'));
  const LicensePlateScans = React.lazy(() =>
    import('../views/license-plate-scans/LicensePlateScans.jsx')
  );
  const Security = React.lazy(() => import('../views/security/index.js'));
  const AiNvr = React.lazy(() => import('../views/security/nvr/index.js'));
  const PaymentsPage = React.lazy(() => import('../views/payments/Payments.jsx'));
  const IntercomTable = React.lazy(() => import('../views/intercom/IntercomTable.jsx'));
  const Documents = React.lazy(() => import('../views/documents/Documents.jsx'));
  const Events = React.lazy(() => import('../views/events/Events.jsx'));

  const { organization } = useSelector((state) => state.Organization);
  const { config: buildingConfig, orgConfig } = useGetConfigs();
  const { roleId } = useSelector((state) => state.auth);

  const [routesList, setRouteList] = useState([]);

  useEffect(() => {
    if (orgConfig != undefined || buildingConfig != undefined) {
      //Add protected routes here
      const protectedRoutes = [
        {
          path: '/security',
          name: 'Security',
          component: Security,
          exact: true,
          viewable:
            roleId == UserRole.SUPER_ADMIN
              ? true
              : buildingConfig?.enable_security_cameras ||
                orgConfig?.enable_security_cameras ||
                buildingConfig?.enable_ai_nvr
        },
        {
          path: '/security/nvr',
          name: 'Intelligent NVR',
          component: AiNvr,
          exact: true,
          viewable:
            roleId == UserRole.SUPER_ADMIN ||
            (isManagerRole(roleId) && !!buildingConfig?.enable_ai_nvr)
        },
        {
          path: '/deliveries',
          name: 'Deliveries',
          component: Deliveries,
          exact: true,
          viewable: roleId == UserRole.SUPER_ADMIN ? true : orgConfig?.enable_deliveries //use this boolean attribute to validate if the route is viewable
        },
        {
          path: '/documents',
          name: 'Documents',
          component: Documents,
          exact: true,
          viewable:
            roleId === UserRole.SUPER_ADMIN ||
            orgConfig?.enable_document_storage ||
            buildingConfig?.enable_document_storage
        },
        {
          path: '/events',
          name: 'Events',
          component: Events,
          exact: true,
          viewable:
            isManagerRole(roleId) ||
            orgConfig?.enable_events ||
            buildingConfig?.enable_events
        },
        {
          path: '/intercom',
          name: 'Intercom',
          component: IntercomTable,
          exact: true,
          viewable:
            roleId == UserRole.SUPER_ADMIN ||
            ((roleId == UserRole.ADMIN || roleId == UserRole.MANAGER) &&
              (orgConfig?.enable_akuvox || buildingConfig?.enable_akuvox))
        },
        {
          path: '/parking',
          name: 'Parking',
          component: LicensePlates,
          exact: true,
          viewable:
            roleId === UserRole.SUPER_ADMIN ||
            (orgConfig?.enable_license_plates &&
              (roleId === UserRole.ADMIN || roleId === UserRole.MANAGER))
        },
        {
          path: '/payments',
          name: 'Payments',
          component: PaymentsPage,
          exact: true,
          viewable:
            roleId === UserRole.SUPER_ADMIN ||
            (orgConfig?.enable_payments &&
              (roleId === UserRole.ADMIN || roleId === UserRole.MANAGER))
        },
        {
          path: '/parking-analytics',
          name: 'Parking Analytics',
          component: LicensePlateScans,
          exact: true,
          viewable:
            roleId === UserRole.SUPER_ADMIN ||
            (orgConfig?.enable_license_plates &&
              (roleId === UserRole.ADMIN || roleId === UserRole.MANAGER))
        }
      ];

      let newRouteList = protectedRoutes.concat(routes);
      setRouteList(newRouteList);
    }
  }, [organization, buildingConfig, orgConfig, roleId]);

  return [routesList];
}

export default useRoutes;
